import { render, staticRenderFns } from "./CustomerSummary.vue?vue&type=template&id=6edb0eda&scoped=true"
import script from "./CustomerSummary.vue?vue&type=script&lang=js"
export * from "./CustomerSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edb0eda",
  null
  
)

export default component.exports